export const CREATE_TASK = "CREATE_TASK";
export const RETRIEVE_TASK = "RETRIEVE_TASK";
export const RETRIEVESINGLE_TASK = "RETRIEVESINGLE_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const DELETE_TASK = "DELETE_TASK";


